import React from "react";
import OperatorServiceTickets from "../../components/dashboard/OperatorServiceTickets";

const OperatorPlatformAdmin = () => (
  <OperatorServiceTickets
    serviceCode="admin"
    title="Administration"
    lead="Les demandes liées aux obligations fiscales et sociales des clients."
  />
);

export default OperatorPlatformAdmin;
